export default function Bg() {
  return (
    <div className="bgs">
      <div class="bg bg2"></div>
      <div class="bg bg3"></div>
    </div>
  );
}
